import bisigmaLogo from '../../business_partners/BiSigma/bisigma-logo.svg';
import codeDesk from './code-desk.jpg';
import kyveilLogo from './kyveil-logo.jpg';
import robuddy from './robuddy.png';
import teamWorkstations from './team-workstations.jpg';
import veridionLogo from './veridion-logo.jpg';
import workspaceCoding from './workspace-coding.jpg';

export const homepageImages = {
  bisigmaLogo,
  codeDesk,
  kyveilLogo,
  robuddy,
  teamWorkstations,
  veridionLogo,
  workspaceCoding
};
